import React from 'react';
import DataQualityCommandCenter from './DataQualityCommandCenter';

const DashboardPage = () => {
  return <DataQualityCommandCenter />;
};

export default DashboardPage;